<template>
    <div class="case_detial no-trans" v-loading="loading">
        <div class="case_detial_box">

            <div class="top_box">
                <img src="@/assets/img/login/Frame.png" alt="">
                <router-link class="span1 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/home">首页</router-link>
                > <router-link class="span2 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/Classroom">法律课堂</router-link>
                > <router-link class="span2 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/Classroom_list_video">视频课堂</router-link> > <span aria-current="page">详情</span>
            </div>
            <div class="detial_flex">
                <div class="inof_box" :class="{inof_box_show:is_show}">
                    <div class="info_pay_btns" v-if="is_show">
                        <div class="info_pay_btns_top"></div>
                        <div class="info_pay_btns_bom">
                            <div v-if="mobile_view" class="mobile_pay_info"><i class="el-icon-lock" aria-hidden="true"></i><div>本课程需付费查看</div><span v-if="nwe_detial.price">￥{{ nwe_detial.price }}</span></div>
                            <div class="btns_pay" role="link" tabindex="0" @keydown.enter.prevent="handle_pay" @click="handle_pay">
                                付费查看
                            </div>
                        </div>
                    </div>
                    <div class="info_1">
                        <div class="title_flex">
                            {{ nwe_detial.title ||''}}
                        </div>
                        <div class="tage_info">
                            <div class="tage_flex">
                                <div class="tege_title">时间：</div>
                                <div class="tege_text">     
                                    {{ nwe_detial.pub_time ||''}}
                                </div>
                            </div>
                            <div class="borders"></div>
                            <div class="tage_flex">
                                <div class="tege_title">{{nwe_detial.cateid_txt}}</div>
                            </div>
                        </div>
                        <div class="btns_flex">
                           
                        </div>
                        <div class="const_box">
                          
                            <div class="const_const" v-html="nwe_detial.content">
                                <!-- 原告上海中原物业顾问有限公司（简称中原公司）诉称：被告陶德华利用中原公司提供的上海市虹口区株洲路某号房屋销售信息，故意跳过中介，私自与卖方直接签订购房合同，违反了《房地产求购确认书》的约定，属于恶意“跳单”行为，请求法院判令陶德华按约支付中原公司违约金1.65万元。
                                被告陶德华辩称：涉案房屋原产权人李某某委托多家中介公司出售房屋，中原公司并非独家掌握该房源信息，也非独家代理销售。陶德华并没有利用中原公司提供的信息，不存在“跳单”违约行为。
                                法院经审理查明：2008年下半年，原产权人李某某到多家房屋中介公司挂牌销售涉案房屋。2008年10月22日，上海某房地产经纪有限公司带陶德华看了该房屋；11月23日，上海某房地产顾问有限公司(简称某房地产顾问公司)带陶德华之妻曹某某看了该房屋；11月27日，中原公司带陶德华看了该房屋，并于同日与陶德华签订了《房地产求购确认书》。该《确认书》第2.4条约定，陶德华在验看过该房地产后六个月内，陶德华或其委托人、代理人、代表人、承办人等与陶德华有关联的人，利用中原公司提供的信息、机会等条件但未通过中原公司而与第三方达成买卖交易的，陶德华应按照与出卖方就该房地产买卖达成的实际成交价的1%，向中原公司支付违约金。当时中原公司对该房屋报价165万元，而某房地产顾问公司报价145万元，并积极与卖方协商价格。11月30日，在某房地产顾问公司居间下，陶德华与卖方签订了房屋买卖合同，成交价138万元。后买卖双方办理了过户手续，陶德华向某房地产顾问公司支付佣金1. 38万元。
                                原告上海中原物业顾问有限公司（简称中原公司）诉称：被告陶德华利用中原公司提供的上海市虹口区株洲路某号房屋销售信息，故意跳过中介，私自与卖方直接签订购房合同，违反了《房地产求购确认书》的约定，属于恶意“跳单”行为，请求法院判令陶德华按约支付中原公司违约金1.65万元。
                                被告陶德华辩称：涉案房屋原产权人李某某委托多家中介公司出售房屋，中原公司并非独家掌握该房源信息，也非独家代理销售。陶德华并没有利用中原公司提供的信息，不存在“跳单”违约行为。
                                法院经审理查明：2008年下半年，原产权人李某某到多家房屋中介公司挂牌销售涉案房屋。2008年10月22日，上海某房地产经纪有限公司带陶德华看了该房屋；11月23日，上海某房地产顾问有限公司(简称某房地产顾问公司)带陶德华之妻曹某某看了该房屋；11月27日，中原公司带陶德华看了该房屋，并于同日与陶德华签订了《房地产求购确认书》。该《确认书》第2.4条约定，陶德华在验看过该房地产后六个月内，陶德华或其委托人、代理人、代表人、承办人等与陶德华有关联的人，利用中原公司提供的信息、机会等条件但未通过中原公司而与第三方达成买卖交易的，陶德华应按照与出卖方就该房地产买卖达成的实际成交价的1%，向中原公司支付违约金。当时中原公司对该房屋报价165万元，而某房地产顾问公司报价145万元，并积极与卖方协商价格。11月30日，在某房地产顾问公司居间下，陶德华与卖方签订了房屋买卖合同，成交价138万元。后买卖双方办理了过户手续，陶德华向某房地产顾问公司支付佣金1. 38万元。
                                原告上海中原物业顾问有限公司（简称中原公司）诉称：被告陶德华利用中原公司提供的上海市虹口区株洲路某号房屋销售信息，故意跳过中介，私自与卖方直接签订购房合同，违反了《房地产求购确认书》的约定，属于恶意“跳单”行为，请求法院判令陶德华按约支付中原公司违约金1.65万元。
                                被告陶德华辩称：涉案房屋原产权人李某某委托多家中介公司出售房屋，中原公司并非独家掌握该房源信息，也非独家代理销售。陶德华并没有利用中原公司提供的信息，不存在“跳单”违约行为。
                                法院经审理查明：2008年下半年，原产权人李某某到多家房屋中介公司挂牌销售涉案房屋。2008年10月22日，上海某房地产经纪有限公司带陶德华看了该房屋；11月23日，上海某房地产顾问有限公司(简称某房地产顾问公司)带陶德华之妻曹某某看了该房屋；11月27日，中原公司带陶德华看了该房屋，并于同日与陶德华签订了《房地产求购确认书》。该《确认书》第2.4条约定，陶德华在验看过该房地产后六个月内，陶德华或其委托人、代理人、代表人、承办人等与陶德华有关联的人，利用中原公司提供的信息、机会等条件但未通过中原公司而与第三方达成买卖交易的，陶德华应按照与出卖方就该房地产买卖达成的实际成交价的1%，向中原公司支付违约金。当时中原公司对该房屋报价165万元，而某房地产顾问公司报价145万元，并积极与卖方协商价格。11月30日，在某房地产顾问公司居间下，陶德华与卖方签订了房屋买卖合同，成交价138万元。后买卖双方办理了过户手续，陶德华向某房地产顾问公司支付佣金1. 38万元。
                                在某房地产顾问公司居间下，陶德华与卖方签订了房屋买卖合同，成交价138万元。后买卖双方办理了过户手续，陶德华向某房地产顾问公司支付。 -->
                            </div>
                             <div class="pl_bq">
                                版权申明：对视频内容享有独家版权，未经许可不得以任何形式复制、转载。
                             </div>
                             <div class="pl_btns">
                                <div class="btns1" role="button" tabindex="0" @keydown.enter.prevent="handle_dianzan" @click="handle_dianzan">
                                    <img src="../../../assets/img/index/comments_case/zan.png" alt="">
                                    点赞
                                    <span v-if="nwe_detial.op">+1</span>
                                </div>
                                <div class="btns1" role="button" tabindex="0" @keydown.enter.prevent="handle_fx" @click="handle_fx">
                                    <img src="../../../assets/img/index/comments_case/fx.png" alt="">
                                    分享
                                </div>
                             </div>
                        </div>
                    </div>
                     
                </div>
                <div class="course_sidebar">
                    <Classroom_new_video_detial ref="Classroom_new_video_detial"></Classroom_new_video_detial>
                </div>
            </div>
        </div>
        <comments_form_pl ref="comments_form_pl"></comments_form_pl>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'

import Classroom_new_video_detial from '@/components/law/Classroom/Classroom_new_video_detial.vue'//右边
import comments_form_pl from '@/components/comments/comments_form_pl.vue'//提交评论


export default {
    components: {
        Classroom_new_video_detial,
        comments_form_pl,
    },
    name: "homes",
    data() {
        return {
            loading:false,
            is_show:false,
            nwe_detial:{},
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_detial()
    },
    methods: {
        get_detial(){
            this.loading=true
            this.$api("lesson", {
                 id:this.$route.query.id
			}, "get").then((res) => {
                this.loading = false
                console.log('法律课堂详情',res)
                if (res.code == 1) {
                   this.nwe_detial=res.data
                   this.is_show=!!res.data.if_pay
                   this.$nextTick(() => {
                       this.$el.querySelectorAll('.const_const video').forEach(video => {
                           video.setAttribute('playsinline', '')
                           video.setAttribute('webkit-playsinline', '')
                       })
                   })
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_dianzan(){
            this.loading=true
            this.$api("lessonOp", {
                id:this.$route.query.id,
                op:'re_up',
			}, "post").then((res) => {
                this.loading = false
                console.log('点赞',res)
                if (res.code == 1) {
                    alertSucc('点赞成功')
                    this.get_detial()
                } else {
                    alertErr(res.msg)
                }
            }); 
        },
        handle_home(){
            this.$router.push({
                path:'/home',
            })
        },
        handle_pay(){
            this.$router.push({
                path:'/Classroom_pay',
                query:{
                    id:this.$route.query.id,
                    price:this.nwe_detial.price
                }
            })
            
        },
        handle_fx(){
            let url=window.location.href
            navigator.clipboard.writeText(url).then(function() {
                alertSucc("链接复制成功！");
            }).catch(function(err) {
                alertErr("复制失败：" + err);
            });
        },
    },

}
</script>
<style scoped lang="less">
.case_detial{
    padding-bottom: 100px;
    background-color: #F5F5F5;
    .case_detial_box{
        width: 1440px;
        margin: auto;
        .top_box{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding: 20px 0;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
        .detial_flex{
            display: flex;
            // align-items: center;
            justify-content: space-between;
            .inof_box{
                width: 1000px;
                .info_1{
                    // width: 1000px;
                    // height: 1429px;
                    padding: 40px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    .title_flex{
                        display: flex;
                        align-items: center;
                       
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 24px;
                        color: #333333; 
                        img{
                            margin-left: 10px;
                            width: 70px;
                            height: 25px;
                        }

                    }
                    .tage_info{
                        display: flex;
                        align-items: center; 
                        padding-top: 16px;

                        .tage_flex{
                            display: flex;
                            align-items: center;
                            .tege_title{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                            }
                            .tege_text{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                span{
                                    color: #377CFD;
                                }
                            }
                        }
                        .borders{
                            width: 0;
                            height: 15px;
                            border-left: 1px solid #999999;
                            margin: 0 20px;
                        }
                    }

                    .btns_flex{
                        display: flex;
                        align-items: center;
                        padding-top: 20px;
                        padding-bottom: 24px;
                        border-bottom: 1px solid #D9D9D9;
                        .btns1{
                            width: 134px;
                            height: 36px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;
                            img{
                                width: 14px;
                                height: 14px;
                                margin-right: 8px;
                            }
                        }
                        .btns2{
                            width: 134px;
                            height: 36px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            margin-left: 16px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                            img{
                                width: 14px;
                                height: 14px;
                                margin-right: 8px;
                            }
                        }
                    }
                    .const_box{
                        padding-top: 24px;
                        .const_flex{
                            display: flex;
                            align-items: center;
                            margin-bottom: 16px;
                            .const_title{
                                width: 100px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                            }
                            .const_text{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                            }
                        }
                        .const_const{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding-bottom: 40px;
                            border-bottom: 1px solid  #D9D9D9;
                        }
                        .pl_bq{
                            padding-top: 24px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;

                        }
                        .pl_btns{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding-top: 32px;
                            .btns1{
                                width: 120px;
                                height: 36px;
                                background: #FFFFFF;
                                border-radius: 18px 18px 18px 18px;
                                border: 1px solid #D7D7D7;
                                cursor: pointer;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                margin-right: 24px;
                                img{
                                    width: 14px;
                                    margin-right: 4px;
                                }
                                span{
                                    color: #377CFD;
                                    padding-left: 4px;
                                }
                            }
                        }
                        .flie_flex{
                            display: flex;
                            align-items: center;
                            padding-top: 23px;
                            .flie_img{
                                display: flex;
                                align-items: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                cursor: pointer;
                                img{
                                    width:16px ;
                                    height: 14px;
                                    margin-right: 10px;
                                }
                            }
                            .flie_name{
                                margin-left: 60px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                cursor: pointer;
                            }
                        }
                    }
                }
                .case_infos{
                    width: 1000px;
                    min-height: 490px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 26px;
                    padding: 25px 32px 36px 32px;
                    .case_titles{
                     
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 24px;
                        color: #333333;
                        padding-bottom: 21px;
                    }
                    .case_texts{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        line-height: 30px;
                    }
                }
                .pl_num_box{
                    width: 100%;
                    height: 50px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    justify-content: center;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #8590A6;
                    margin-top: 20px;
                    margin-bottom: 24px;
                }
                .pl_infos{
                    width: 100%;
                    padding: 40px 40px 23px 40px ;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-bottom: 25px;
                    .pl_user{
                        display: flex;
                        // align-items: center;
                        justify-content: space-between;
                        .pl_user_left{
                            display: flex;
                            align-items: center;
                            .user_img{
                                width: 64px;
                                height: 64px;
                                img{
                                    width: 64px;
                                    height: 64px;
                                    border-radius: 50%;
                                }
                            }
                            .user_info{
                                padding-left: 24px;
                                .user_name{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 24px;
                                    color: #333333;
                                }
                                .user_time{
                                    padding-top: 11px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #666666;
                                }

                            }
                        }
                        
                        .pl_user_right{
                            .user_nums{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #8590A6;
                            }
                        }
                        
                    }
                    .pl_const_box{
                        .pl_titles{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #333333;
                            padding-top: 24px;
                        }
                        .pl_consts{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding-top: 15px;
                        }
                    }
                    .pl_btns{
                        display: flex;
                        align-items: center;
                        padding-top: 40px;
                        .btns1{
                            padding: 8px 23px;
                            background: rgba(55, 124, 253, 0.08);
                            border-radius: 4px 4px 4px 4px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #377CFD;
                            cursor: pointer;
                            img{
                                width: 14px;
                            }
                        }
                        .btns2{
                            margin-left: 8px;
                            width: 36px;
                            height: 36px;
                            background: rgba(55, 124, 253, 0.08);
                            border-radius: 4px 4px 4px 4px;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            img{
                                width: 14px;
                            }
                        }
                        .btns3{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            margin-left: 24px;
                            cursor: pointer;
                            img{
                                width: 13px;
                                margin-right: 4px;
                            }
                        }
                    }
                    
                }
                .comment_section{
                    // width: 1000px;
                    // height: 602px;
                    padding: 23px 30px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    .title_btns{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .titles{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 18px;
                            color: #333333;
                        }
                        .btns{
                            display: flex;
                            align-items: center;
                            .btns1{
                                padding: 8px 23px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                background: #377CFD;
                                background:rgba(55, 124, 253, 0.08);
                                border-radius: 4px 4px 4px 4px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #377CFD;

                                img{
                                    width:14px ;
                                    height: 14px;
                                    margin-right: 8px;
                                }
                            }
                            .btns2{
                                width: 36px;
                                height: 36px;
                                background:rgba(55, 124, 253, 0.08);
                                border-radius: 4px 4px 4px 4px;
                                margin-left: 8px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                img{
                                    width:14px ;
                                    height: 14px;
                                }
                            }
                            .btns3{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                text-align: center;
                                margin-left: 24px;
                                cursor: pointer;
                                img{
                                    width:13px ;
                                    // height: 12px;
                                    // margin-right: 8px;
                                }

                            }
                        }
                    }
                    .comment_list{
                        padding-top: 24px;
                        .items{
                            width: 940px;
                            min-height: 220px;
                            background: #FFFFFF;
                            border-radius: 3px 3px 3px 3px;
                            border: 1px solid #D7DEE5;
                            margin-bottom: 17px;
                            padding: 21px 29px 30px 25px;
                            .items_top{
                                display: flex;
                                .user_imgs{
                                    width: 64px;
                                    height: 64px;
                                    img{
                                        width: 64px;
                                        height: 64px;
                                        border-radius: 50%;
                                    }
                                }
                                .user_info{
                                    width: 200px;
                                    padding:  8px 0;
                                    padding-left: 24px;
                                    display: flex;
                                    flex-wrap: wrap;
                                    align-content: space-between;
                                    .names{
                                        width: 100%;
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #666666;

                                    }
                                    .times{
                                        width: 100%;
                                       
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 12px;
                                        color: #666666;

                                    }
                                }
                                .comment_num{
                                    .num_flex{
                                        display: flex;
                                        align-items: center;
                                        .nums{
                                            img{
                                                width: 21px;
                                                height: 20px;
                                            }
                                        }
                                    }
                                    .comment_text{
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #333333;
                                        padding-top: 20px;
                                    }
                                }
                            }
                            .items_bom{
                                // width: 886px;
                                min-height: 78px;
                                background: #F5F5F5;
                                border-radius: 4px 4px 4px 4px;
                                margin-top: 27px;

                                padding:18px 52px 16px 22px ;
                            
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;

                            }
                        }
                        .comment_num_btns{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            span{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #8590A6;
                                cursor: pointer;
                            }

                        }
                    }
                }
                .comprehensive_reviews{
                    width: 1000px;
                    min-height: 194px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 20px;
                    padding: 13px 52px 10px 28px;
                    .review_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;

                    }
                    .review_text{
                        padding-top: 24px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        line-height: 30px;
                    }
                }
                .announcement_box{
                    width: 1000px;
                    min-height: 271px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    padding: 13px 52px 14px 28px;
                    margin-top: 16px;
                    .announcement_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;
                        text-align: center;

                    }
                    .announcement_text{
                        padding-top: 24px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        line-height: 32px;
                    }
                }
            }
            .inof_box_show{
                // width: 100%;
                position: relative;
                height: 1270px;
                overflow: hidden;
                background-color: #FFFFFF;
                .info_pay_btns{
                    width: 100%;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    .info_pay_btns_top{
                        width: 100%;
                        height: 118px;
                        background: linear-gradient( 180deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);
                        border-radius: 0px 0px 0px 0px;
                    }
                    .info_pay_btns_bom{
                        width: 100%;
                        height: 769px;
                        background: #FFFFFF;
                        border-radius: 0px 0px 0px 0px;
                        display: flex;
                        justify-content: center;
                        padding-top: 10px;
                        .btns_pay{
                            width: 134px;
                            height: 36px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            text-align: center;
                            line-height: 36px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;
                        }
                    }
                   
                   
                   
                }
            }
        }
    }
}

</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .case_detial.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .case_detial.no-trans .case_detial_box .top_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        padding: 16px 0;
    }
    .case_detial.no-trans .case_detial_box .top_box img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 {
        padding: 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .title_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 24px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .title_flex img {
        margin-left: 10px;
        width: 70px;
        height: 25px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info .tage_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info .tage_flex .tege_title {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info .tage_flex .tege_text {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info .borders {
        height: 15px;
        margin: 0 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex .btns1 {
        width: 134px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex .btns1 img {
        width: 14px;
        height: 14px;
        margin-right: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex .btns2 {
        width: 134px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        margin-left: 16px;
        font-size: 14px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex .btns2 img {
        width: 14px;
        height: 14px;
        margin-right: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box {
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .const_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .const_flex .const_title {
        width: 100px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .const_flex .const_text {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .const_const {
        font-size: 14px;
        padding-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .pl_bq {
        padding-top: 16px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .pl_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .pl_btns .btns1 {
        width: 120px;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-right: 16px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .pl_btns .btns1 img {
        width: 14px;
        margin-right: 4px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .pl_btns .btns1 span {
        padding-left: 4px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .flie_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .flie_flex .flie_img {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .flie_flex .flie_img img {
        width: 16px;
        height: 14px;
        margin-right: 10px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .flie_flex .flie_name {
        margin-left: 16px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .case_infos {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
        padding: 16px 16px 16px 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .case_infos .case_titles {
        font-size: 24px;
        padding-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .case_infos .case_texts {
        font-size: 14px;
        line-height: 30px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_num_box {
        height: auto;
        border-radius: 0px 0px 0px 0px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 16px;
        margin-top: 16px;
        margin-bottom: 16px;
        min-height: 44px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos {
        padding: 16px 16px 16px 16px;
        border-radius: 0px 0px 0px 0px;
        margin-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .pl_user_left {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .pl_user_left .user_img {
        width: 64px;
        height: 64px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .pl_user_left .user_img img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .pl_user_left .user_info {
        padding-left: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .pl_user_left .user_info .user_name {
        font-size: 24px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .pl_user_left .user_info .user_time {
        padding-top: 11px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .pl_user_right .user_nums {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_const_box .pl_titles {
        font-size: 16px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_const_box .pl_consts {
        font-size: 14px;
        padding-top: 15px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_btns .btns1 {
        padding: 8px 16px;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_btns .btns1 img {
        width: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_btns .btns2 {
        margin-left: 8px;
        width: 36px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_btns .btns2 img {
        width: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_btns .btns3 {
        font-size: 14px;
        margin-left: 16px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_btns .btns3 img {
        width: 13px;
        margin-right: 4px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section {
        padding: 16px 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .titles {
        font-size: 18px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns1 {
        padding: 8px 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns1 img {
        width: 14px;
        height: 14px;
        margin-right: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns2 {
        width: 36px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        margin-left: 8px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns2 img {
        width: 14px;
        height: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns3 {
        font-size: 14px;
        margin-left: 16px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns3 img {
        width: 13px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list {
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 3px 3px 3px 3px;
        margin-bottom: 16px;
        padding: 16px 16px 16px 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_imgs {
        width: 64px;
        height: 64px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_imgs img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_info {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        padding: 8px 0;
        padding-left: 16px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_info .names {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_info .times {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .comment_num .num_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .comment_num .num_flex .nums img {
        width: 21px;
        height: 20px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .comment_num .comment_text {
        font-size: 14px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_bom {
        border-radius: 4px 4px 4px 4px;
        margin-top: 16px;
        padding: 16px 16px 16px 16px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .comment_num_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .comment_num_btns span {
        font-size: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comprehensive_reviews {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
        padding: 13px 16px 10px 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comprehensive_reviews .review_title {
        font-size: 18px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comprehensive_reviews .review_text {
        padding-top: 16px;
        font-size: 14px;
        line-height: 30px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .announcement_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        padding: 13px 16px 14px 16px;
        margin-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .announcement_box .announcement_title {
        font-size: 18px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .announcement_box .announcement_text {
        padding-top: 16px;
        font-size: 14px;
        line-height: 32px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box_show {
        min-height: 0;
        height: auto;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box_show .info_pay_btns .info_pay_btns_top {
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box_show .info_pay_btns .info_pay_btns_bom {
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 10px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box_show .info_pay_btns .info_pay_btns_bom .btns_pay {
        width: 134px;
        height: 36px;
        border-radius: 4px 4px 4px 4px;
        line-height: 36px;
        font-size: 14px;
    }
}
@media (max-width: 1024px) {
    .case_detial.no-trans {
        box-sizing: border-box;
        padding: 0 12px 28px;
        .case_detial_box {
            .top_box { gap: 4px 6px; padding: 4px 0; min-height: 48px; font-size: 13px; line-height: 22px; }
            .top_box img { width: 13px; height: 13px; margin-right: 0; }
            .top_box .breadcrumb_link { display: inline-flex; align-items: center; min-height: 44px; }
            .detial_flex {
                display: flex; flex-direction: column; align-items: stretch; gap: 20px;
                .inof_box {
                    .info_1 {
                        padding: 20px 16px;
                        .title_flex { display: block; font-size: 21px; font-weight: 600; line-height: 32px; color: #303846; overflow-wrap: anywhere; }
                        .tage_info { gap: 6px 12px; padding-top: 10px; align-items: center; }
                        .tage_info .tage_flex { gap: 0; }
                        .tage_info .tage_flex .tege_title, .tage_info .tage_flex .tege_text { font-size: 13px; line-height: 22px; color: #7b8491; }
                        .tage_info .borders { display: none; }
                        .btns_flex { display: none; }
                        .const_box {
                            padding-top: 18px;
                            .const_const { padding: 0 0 16px; font-size: 16px; line-height: 1.9; color: #43526a; overflow-wrap: anywhere; border-bottom-color: #edf0f4; }
                            .const_const /deep/ p { margin: 0 0 14px; }
                            .const_const /deep/ h1, .const_const /deep/ h2, .const_const /deep/ h3 { font-size: 18px; line-height: 29px; margin: 20px 0 10px; }
                            .const_const /deep/ img { display: block; max-width: 100% !important; height: auto !important; margin: 12px auto; }
                            .const_const /deep/ video, .const_const /deep/ iframe, .const_const /deep/ embed { display: block; box-sizing: border-box; width: 100% !important; max-width: 100% !important; height: auto !important; aspect-ratio: ~"16 / 9"; margin: 12px 0; border: 0; border-radius: 4px; background: #111; object-fit: contain; }
                            .const_const /deep/ table { display: block; max-width: 100%; overflow-x: auto; }
                            .const_const /deep/ pre { max-width: 100%; overflow-x: auto; white-space: pre-wrap; }
                            .const_const /deep/ ul, .const_const /deep/ ol { padding-left: 22px; }
                            .pl_bq { padding-top: 12px; font-size: 13px; line-height: 23px; color: #8a929e; }
                            .pl_btns { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; padding-top: 18px; }
                            .pl_btns .btns1 { box-sizing: border-box; width: 100%; height: 44px; min-height: 44px; margin: 0; padding: 0 8px; gap: 4px; border-radius: 4px; font-size: 14px; border-color: #dfe5ee; }
                            .pl_btns .btns1 img { width: 16px; height: 16px; object-fit: contain; margin: 0; }
                        }
                    }
                }
                .inof_box_show {
                    display: flex; flex-direction: column; height: auto; overflow: hidden;
                    .info_1 { order: 0; padding-bottom: 0; }
                    .info_1 .const_box { display: none; }
                    .info_pay_btns {
                        order: 1; position: static; padding: 20px 16px 24px; box-sizing: border-box;
                        .info_pay_btns_top { display: none; }
                        .info_pay_btns_bom { display: flex; flex-direction: column; align-items: stretch; height: auto; padding: 20px 16px 16px; gap: 16px; border: 1px solid #e7edf5; border-radius: 6px; background: #f8faff; }
                        .info_pay_btns_bom .mobile_pay_info { display: flex; flex-direction: column; align-items: center; gap: 8px; font-size: 15px; line-height: 24px; color: #43526a; }
                        .info_pay_btns_bom .mobile_pay_info i { color: #377cfd; font-size: 28px; }
                        .info_pay_btns_bom .mobile_pay_info span { color: #ee605c; font-size: 24px; font-weight: 600; line-height: 32px; }
                        .info_pay_btns_bom .btns_pay { width: 100%; height: 46px; line-height: 46px; font-size: 15px; border-radius: 4px; }
                    }
                }
                .course_sidebar { width: 100%; min-width: 0; }
                .course_sidebar /deep/ .rights_box.no-trans {
                    .new_lists { background: #fff; padding: 0 14px; }
                    .new_lists .new_item { display: grid; grid-template-columns: 88px minmax(0, 1fr); gap: 12px; align-items: start; margin: 0; padding: 14px 0; border-bottom: 1px solid #edf0f4; box-shadow: none; }
                    .new_lists .new_item .new_img { width: 88px; height: 70px; }
                    .new_lists .new_item .new_img img { width: 100%; height: 100%; object-fit: cover; }
                    .new_lists .new_item .new_info { min-width: 0; padding: 0; }
                    .new_lists .new_item .new_info .new_title { font-size: 15px; line-height: 24px; overflow-wrap: anywhere; }
                    .new_lists .new_item .new_info .new_icons { display: flex; flex-wrap: wrap; gap: 4px 10px; padding-top: 6px; }
                    .new_lists .new_item .new_info .new_icons .icons { margin: 0; font-size: 13px; line-height: 20px; overflow-wrap: anywhere; }
                    .new_lists .new_item .new_info .new_icons .icons img { width: 13px; height: 13px; object-fit: contain; margin-right: 4px; }
                }
            }
        }
        [role="button"]:focus-visible, [role="link"]:focus-visible { outline: 2px solid #377cfd; outline-offset: 2px; }
    }
}
</style>
